"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = save;

var _element = require("@wordpress/element");

var _classnames = _interopRequireDefault(require("classnames"));

var _blockEditor = require("@wordpress/block-editor");

/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */
function save(_ref) {
  let {
    attributes
  } = _ref;
  const {
    textAlign,
    content
  } = attributes;
  const className = (0, _classnames.default)({
    [`has-text-align-${textAlign}`]: textAlign
  });
  return (0, _element.createElement)("pre", _blockEditor.useBlockProps.save({
    className
  }), (0, _element.createElement)(_blockEditor.RichText.Content, {
    value: content
  }));
}
//# sourceMappingURL=save.js.map